import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import {} from 'react';
const HiddenDetails = (props) => (_jsxs("div", { css: { position: 'relative' }, children: [_jsx("div", { css: [
                { '> *': { transition: '.5s', filter: 'brightness(1) blur(0)' } },
                props.hidden &&
                    (props.variant === 'dim'
                        ? { '> *': { filter: 'brightness(0.8) blur(4px)' } }
                        : { '> *': { filter: 'brightness(1.2) blur(4px)' } }),
            ], children: props.children }), _jsx("div", { css: [
                {
                    position: 'absolute',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    inset: 0,
                    transition: '.5s',
                },
                !props.hidden && {
                    opacity: 0,
                    pointerEvents: 'none',
                },
            ], children: props.overlay })] }));
export default HiddenDetails;
//# sourceMappingURL=HiddenDetails.js.map